(function(){
  "use strict";

  if (window.__PO_OUTILS_TRILANG_PROTECTED_20260401__) return;
  window.__PO_OUTILS_TRILANG_PROTECTED_20260401__ = true;

  var ROOT_SEL = '.po-axis-section[data-po-lex-id="outils"]';
  var STORAGE_KEY = 'po_lex_lang';
  var STORAGE_KEY_COMPAT = 'goody_gp_lang';
  var DEFAULT_LANG = 'fr';

  var URLS = {
    title: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/outils_posoennoiaux_2.png?v=1746289934',
    lexicon: 'https://goodyart.store/pages/lexique-simplifie/',
    outils: 'https://goodyart.store/pages/outils',
    sujet: 'https://goodyart.store/pages/sujet-pluriel',
    addition: 'https://goodyart.store/pages/addition-synchetique',
    instantane: 'https://goodyart.store/pages/instantane-multiple',
    superposition: 'https://goodyart.store/pages/superposition-de-perspectives',
    sujet_concept: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sujet_pluriel_2.png?v=1746214788',
    sujet_function: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sujet_pluriel_fonction_2.png?v=1746214789',
    sujet_guide: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_3_copie.png?v=1750341338',
    addition_concept: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Addition_Synchretique.png?v=1769951779',
    addition_function: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Addition_synchretique_Fonction_2.png?v=1746214790',
    addition_guide: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_10.png?v=1749985981',
    instantane_concept: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Instantane_mutiple_2.png?v=1746214804',
    instantane_function: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Instantane_mutiple_fonction_2.png?v=1746214804',
    instantane_guide: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_9.png?v=1750285321',
    superposition_concept: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Supperposition_de_perspective_2.png?v=1746214790',
    superposition_function: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Supperposition_de_perspective_fonction_2.png?v=1746214788',
    superposition_guide: 'https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_8.png?v=1750335789'
  };

  var CANON = {
    title: 'Outils',
    tools: 'Outils posœnnoïaux',
    posoennoisme: 'Posœnnoïsme',
    posoennoia: 'Posœnnoïa',
    organon: 'Organon posœnnoïal',
    addition: 'Addition synchrêtique',
    instantane: 'Instantané multiple',
    superposition: 'Superposition de perspectives',
    sujet: 'Sujet pluriel',
    rezonans: 'RéZonans',
    peroptissimisme: 'Péroptissimisme',
    illusion: 'Illusion',
    alioevolution: 'Aliœvolution',
    posoennoiaque: 'Posœnnoïaque',
    posoennoique: 'Posœnnoïque',
    modalites: 'Modalités opératives',
    katupirsia: 'Katûpirsia',
    axis: 'Axis'
  };

  var UI = {
    fr: {
      labels: {
        concept: 'Idéogramme conceptuel',
        function: 'Idéogramme fonctionnel',
        guide: 'Nombre-guide',
        open: 'déplier',
        see_page: 'Voir la page',
        choose_lang: 'Choisir la langue'
      }
    },
    en: {
      labels: {
        concept: 'Conceptual ideogram',
        function: 'Functional ideogram',
        guide: 'Guide-number',
        open: 'expand',
        see_page: 'Open page',
        choose_lang: 'Choose language'
      }
    },
    es: {
      labels: {
        concept: 'Ideograma conceptual',
        function: 'Ideograma funcional',
        guide: 'Número-guía',
        open: 'desplegar',
        see_page: 'Ver la página',
        choose_lang: 'Elegir idioma'
      }
    }
  };

  function clampStr(v){ return (v == null) ? '' : String(v); }
  function normLang(v){
    var s = clampStr(v).toLowerCase().trim().replace(/_/g, '-');
    if (s === 'fr' || s === 'fr-fr' || s === 'fr_ca' || s.indexOf('fr') === 0) return 'fr';
    if (s === 'en' || s.indexOf('en') === 0) return 'en';
    if (s === 'es' || s.indexOf('es') === 0) return 'es';
    return DEFAULT_LANG;
  }

  function readLang(){
    var v = '';
    try{ v = localStorage.getItem(STORAGE_KEY) || ''; }catch(e){ v = ''; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ''; }catch(_e){ v = ''; }
    }
    if (v) return normLang(v);
    try{
      var dl = document && document.documentElement ? (document.documentElement.getAttribute('lang') || '') : '';
      if (dl) return normLang(dl);
    }catch(__e){}
    return DEFAULT_LANG;
  }

  function storeLang(lang){
    var L = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, L); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, L); }catch(_e){}
    try{ document.documentElement.setAttribute('lang', L); }catch(__e){}
    return L;
  }

  function notifyLocaleChanged(){
    try{ window.dispatchEvent(new Event('po:locale-changed')); }
    catch(e){
      try{
        var ev = document.createEvent('Event');
        ev.initEvent('po:locale-changed', true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  function canon(txt){
    return '<span class="notranslate" translate="no" data-po-protect="1">' + clampStr(txt) + '</span>';
  }

  function lab(lang, key){
    var bucket = (UI[normLang(lang)] && UI[normLang(lang)].labels) || {};
    return bucket[key] || key;
  }

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#39;');
  }

  function escapeRegExp(s){ return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function uniqPush(arr, v, seen){ var k = String(v || ''); if (!k || seen[k]) return; seen[k] = true; arr.push(k); }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;
    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, '’'), seen);
    uniqPush(out, t.replace(/œ/g, 'oe').replace(/Œ/g, 'OE'), seen);
    uniqPush(out, t.replace(/oe/g, 'œ').replace(/OE/g, 'Œ'), seen);
    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(_e){}
    return [
      CANON.posoennoisme, CANON.posoennoia, CANON.organon, CANON.tools,
      CANON.addition, CANON.instantane, CANON.superposition, CANON.sujet,
      CANON.rezonans, CANON.peroptissimisme, CANON.illusion, CANON.alioevolution,
      CANON.posoennoiaque, CANON.posoennoique, CANON.modalites,
      CANON.katupirsia, CANON.axis, 'Goodÿ', 'ADAGP'
    ];
  }

  var __PO_PROTECT_CACHE__ = { key:'', re:null };

  function ensureProtectEngineReady(){
    var key = 'fr-canon';
    if (__PO_PROTECT_CACHE__.key === key && __PO_PROTECT_CACHE__.re) return;
    var base = getSimplifiedLexiqueFRList();
    var all = [];
    var seen = Object.create(null);
    for (var i = 0; i < base.length; i++){
      var vars = buildVariants(base[i]);
      for (var j = 0; j < vars.length; j++) uniqPush(all, vars[j], seen);
    }
    all.sort(function(a,b){ return b.length - a.length; });
    try{
      __PO_PROTECT_CACHE__.re = all.length ? new RegExp('(' + all.map(escapeRegExp).join('|') + ')', 'g') : null;
    }catch(e){ __PO_PROTECT_CACHE__.re = null; }
    __PO_PROTECT_CACHE__.key = key;
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    if (el.getAttribute && el.getAttribute('data-po-protect') === '1') return true;
    var tr = el.getAttribute && el.getAttribute('translate');
    if (tr && String(tr).toLowerCase() === 'no') return true;
    var cls = el.className || '';
    if (typeof cls === 'string' && (cls.indexOf('notranslate') !== -1 || cls.indexOf('po-lex-protect') !== -1 || cls.indexOf('po-lex-locknode') !== -1)) return true;
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;
    var txt = textNode.nodeValue;
    if (!txt) return;
    re.lastIndex = 0;
    if (!re.test(txt)) return;
    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;
    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      if (start > last) frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      var span = doc.createElement('span');
      span.setAttribute('translate', 'no');
      span.setAttribute('data-po-protect', '1');
      span.className = 'po-lex-protect notranslate';
      span.textContent = match;
      frag.appendChild(span);
      last = start + match.length;
      if (!match.length) break;
    }
    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsHTML(html){
    var s = clampStr(html);
    if (!s) return '';
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return s;
    var tpl = document.createElement('template');
    tpl.innerHTML = s;
    var root = tpl.content || tpl;
    var walker;
    try{
      walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n){
          if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
          if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }, false);
    }catch(e){ return s; }
    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i = 0; i < nodes.length; i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;
    var walker;
    try{
      walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode: function(n){
          if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
          if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
          var p = n.parentNode;
          var pn = p && p.nodeName ? p.nodeName : '';
          if (pn === 'SCRIPT' || pn === 'STYLE') return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }, false);
    }catch(e){ return; }
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) protectTextNode(document, nodes[i]);
  }

  function setSlotText(root, slot, value){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (node) node.textContent = clampStr(value);
  }

  function setSlotTextLexical(root, slot, value){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.setAttribute('translate', 'no');
    node.setAttribute('data-po-protect', '1');
    if ((node.className || '').indexOf('notranslate') === -1) node.className = ((node.className || '') + ' notranslate').trim();
    node.textContent = clampStr(value);
  }

  function setSlotHTML(root, slot, value){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (node) node.innerHTML = protectKeywordsHTML(value);
  }

  function setImage(root, slot, url, alt){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.src = clampStr(url || '');
    node.alt = clampStr(alt || '');
  }

  function buildBadge(lang, label, img, text){
    return (
      '<span class="po-tools-badge">' +
        '<span class="po-tools-badge__label">' + escapeHTML(label) + '</span>' +
        '<span class="po-tools-badge__media" aria-hidden="true">' +
          '<img class="po-tools-badge__img" src="' + clampStr(img) + '" alt="" loading="lazy" decoding="async" />' +
        '</span>' +
        '<span class="po-tools-badge__text">' + protectKeywordsHTML(text) + '</span>' +
      '</span>'
    );
  }

  function buildToolCard(lang, cfg){
    return (
      '<article class="po-tool-card">' +
        '<a class="po-tool-card__title" href="' + clampStr(cfg.href) + '">' + protectKeywordsHTML(cfg.title) + '</a>' +
        '<div class="po-tool-card__media-label">' + escapeHTML(lab(lang, 'concept')) + '</div>' +
        '<div class="po-tool-card__media" aria-hidden="true">' +
          '<img class="po-tool-card__img" src="' + clampStr(cfg.concept_img) + '" alt="" loading="lazy" decoding="async" />' +
        '</div>' +
        '<div class="po-tool-card__badges">' +
          buildBadge(lang, lab(lang, 'function'), cfg.function_img, cfg.function_text) +
          buildBadge(lang, lab(lang, 'guide'), cfg.guide_img, cfg.guide_text) +
        '</div>' +
        '<p class="po-tool-card__desc">' + protectKeywordsHTML(cfg.desc) + '</p>' +
        '<div class="po-tool-card__linkline"><a href="' + clampStr(cfg.href) + '">' + escapeHTML(lab(lang, 'see_page')) + '</a></div>' +
      '</article>'
    );
  }

  function renderListInto(root, slot, items){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = '';
    (items || []).forEach(function(item){
      var li = document.createElement('li');
      li.innerHTML = protectKeywordsHTML(item);
      node.appendChild(li);
    });
  }

  function renderWordBlocks(root, slot, blocks){
    var node = root.querySelector('[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = '';
    (blocks || []).forEach(function(block){
      var wrap = document.createElement('div');
      wrap.className = 'po-axis-wb';
      wrap.innerHTML =
        '<div class="po-axis-wb__h">' + protectKeywordsHTML(block.head) + '</div>' +
        '<div class="po-axis-wb__t">' + protectKeywordsHTML(block.text) + '</div>';
      node.appendChild(wrap);
    });
  }

  function buildExampleBox(F){
    return '<p><strong>' + escapeHTML(F.example_title) + '</strong> ' + protectKeywordsHTML(F.example) + '</p>';
  }

  function toolsFor(lang){
    return [
      {
        title: canon(CANON.addition),
        href: URLS.addition,
        concept_img: URLS.addition_concept,
        function_img: URLS.addition_function,
        guide_img: URLS.addition_guide,
        function_text: canon(CANON.addition),
        guide_text: '10',
        desc: {
          fr: 'Intégration dynamique de sources hétérogènes dans une construction harmonique et transformatrice sans réduction uniforme.',
          en: 'Dynamic integration of heterogeneous sources within a harmonious and transformative construction without uniform reduction.',
          es: 'Integración dinámica de fuentes heterogéneas en una construcción armónica y transformadora sin reducción uniforme.'
        }[lang]
      },
      {
        title: canon(CANON.instantane),
        href: URLS.instantane,
        concept_img: URLS.instantane_concept,
        function_img: URLS.instantane_function,
        guide_img: URLS.instantane_guide,
        function_text: canon(CANON.instantane),
        guide_text: '9',
        desc: {
          fr: 'Perception co-présente de différentes temporalités, expériences et niveaux d’interprétation dans un même instant vibrant.',
          en: 'Co-present perception of different temporalities, experiences and interpretive levels within the same vibrant instant.',
          es: 'Percepción copresente de distintas temporalidades, experiencias y niveles de interpretación en un mismo instante vibrante.'
        }[lang]
      },
      {
        title: canon(CANON.superposition),
        href: URLS.superposition,
        concept_img: URLS.superposition_concept,
        function_img: URLS.superposition_function,
        guide_img: URLS.superposition_guide,
        function_text: canon(CANON.superposition),
        guide_text: '8',
        desc: {
          fr: 'Coexistence active de plusieurs angles de vue, lectures et plans d’expérience sans hiérarchie rigide.',
          en: 'Active coexistence of several viewpoints, readings and planes of experience without rigid hierarchy.',
          es: 'Coexistencia activa de varios ángulos de vista, lecturas y planos de experiencia sin jerarquía rígida.'
        }[lang]
      },
      {
        title: canon(CANON.sujet),
        href: URLS.sujet,
        concept_img: URLS.sujet_concept,
        function_img: URLS.sujet_function,
        guide_img: URLS.sujet_guide,
        function_text: canon(CANON.sujet),
        guide_text: '3',
        desc: {
          fr: 'Espace vivant de pluralité intérieure où récits, voix, rythmes et apports trouvent leur juste vibration pour l’Organon.',
          en: 'Living space of inner plurality where narratives, voices, rhythms and contributions find their fitting vibration for the Organon.',
          es: 'Espacio vivo de pluralidad interior donde relatos, voces, ritmos y aportes encuentran su vibración justa para el Organon.'
        }[lang]
      }
    ];
  }

  function buildToolCards(lang){
    return toolsFor(lang).map(function(item){ return buildToolCard(lang, item); }).join('');
  }

  function content(lang){
    var toolsTitle = canon(CANON.tools);
    var addition = canon(CANON.addition);
    var instantane = canon(CANON.instantane);
    var superposition = canon(CANON.superposition);
    var sujet = canon(CANON.sujet);
    var rezonans = canon(CANON.rezonans);
    var peropt = canon(CANON.peroptissimisme);
    var illusion = canon(CANON.illusion);
    var alio = canon(CANON.alioevolution);
    var posoeA = canon(CANON.posoennoiaque);
    var posoeI = canon(CANON.posoennoique);
    var modalites = canon(CANON.modalites);
    var organon = canon(CANON.organon);
    var posoennoia = canon(CANON.posoennoia);
    var axis = canon(CANON.katupirsia) + ' 1 – ' + canon(CANON.axis);

    if (lang === 'en') {
      return {
        title: CANON.title,
        kicker: 'Excerpt from <em>' + axis + '</em><br />(Perceptive and integrative activators of the ' + organon + ')',
        h_def: 'Operative definition',
        def_short: toolsTitle + ' are the perceptive and integrative activators: ' + addition + ', ' + superposition + ', ' + instantane + ', ' + sujet + '. Fed by the oscillation of the Gears, they transform disparate flows into operative matrices.',
        def_long:
          '<p>' + toolsTitle + ' act as passage-agents: filtering entities capable of transmuting the vibratory matter of ' + posoennoia + ' into activable devices. Each one carries a protocol of arrangement between the formless and the form, between intuitive density and symbolic structure.</p>' +
          '<p>' + addition + ' works through adjustment and recombination; ' + superposition + ' opens multi-angled readings; ' + instantane + ' widens perception through simultaneous temporal strata; ' + sujet + ' stabilizes this plurality without flattening it.</p>' +
          '<p>Each Tool is moved by the crossed activation of ' + posoeA + ' and ' + posoeI + '. Accumulation explores, gathers and multiplies; refinement condenses, structures and keeps coherence. Their interaction with ' + rezonans + ', ' + peropt + ', ' + illusion + ' and ' + alio + ' nourishes the emergence of ' + modalites + '.</p>',
        h_tools: 'The four tools',
        h_features: 'Operative dynamics',
        features: [
          'Perceptive and integrative activators of the Axis.',
          'They convert heterogeneous flows into operative matrices.',
          'They are driven by the crossed action of the Posœnnoïac and Posœnnoïc Gears.',
          'They work in living interdependence with the four Pillars.',
          'They participate in the birth of Operative Modalities.'
        ],
        h_questions: 'Applications / markers',
        questions: [
          'Which Tool best fits the current need: to add, to widen the reading, to hold several times at once, or to stabilize plurality?',
          'Should the process begin with accumulation or with refinement?',
          'Which Pillar is already active under the surface of the Tool?',
          'What kind of matrix must be produced here: narrative, conceptual, visual, relational, temporal?'
        ],
        example_title: 'Ex.',
        example: 'A work can pass through ' + addition + ' to integrate heterogeneous materials, through ' + superposition + ' to open several readings, through ' + instantane + ' to densify the instant, and through ' + sujet + ' to give that plurality a coherent living hold.',
        h_family: 'Systemic links',
        family_1: '<p><strong>With the Pillars:</strong> ' + rezonans + ' tunes, ' + peropt + ' relaunches, ' + illusion + ' unveils, and ' + alio + ' transforms through alterity. The Tools receive these impulses and make them workable.</p>',
        family_2: '<p><strong>With the Gears:</strong> ' + posoeA + ' pushes the Tools to collect, explore and complexify; ' + posoeI + ' condenses, structures and stabilizes what has been gathered. This tension gives rise to ' + modalites + '.</p>',
        h_wordbuild: 'Construction / group logic',
        word_blocks: [
          { head: '1) Activation', text: 'The Tools do not merely describe: they trigger an operation in perception, thought, creation and relation.' },
          { head: '2) Passage', text: 'They transform raw material into workable form, without reducing the multiplicity they host.' },
          { head: '3) Interdependence', text: 'Their action never occurs alone: it is nourished by the Pillars, moved by the Gears, and prolonged in Operative Modalities.' }
        ],
        word_notes: [
          'Guide-numbers: 10 / 9 / 8 / 3.',
          'Shared logic: perception, arrangement, widening, stabilization.',
          'Group status: four fundamental tools of the Axis.'
        ],
        cta_translate: 'Suggest a translation for the concept'
      };
    }

    if (lang === 'es') {
      return {
        title: CANON.title,
        kicker: 'Extracto de <em>' + axis + '</em><br />(Activadores perceptivos e integrativos del ' + organon + ')',
        h_def: 'Definición operativa',
        def_short: toolsTitle + ' son los activadores perceptivos e integrativos: ' + addition + ', ' + superposition + ', ' + instantane + ', ' + sujet + '. Alimentados por la oscilación de los Engranajes, transforman flujos dispares en matrices operativas.',
        def_long:
          '<p>' + toolsTitle + ' actúan como agentes de paso: entidades filtrantes capaces de transmutar la materia vibratoria de ' + posoennoia + ' en dispositivos activables. Cada una porta un protocolo de agenciamiento entre lo informe y la forma, entre la densidad intuitiva y la estructura simbólica.</p>' +
          '<p>' + addition + ' opera por ajuste y recombinación; ' + superposition + ' abre lecturas multiangulares; ' + instantane + ' amplía la percepción por estratos temporales simultáneos; ' + sujet + ' estabiliza esa pluralidad sin uniformarla.</p>' +
          '<p>Cada Herramienta es puesta en movimiento por la activación cruzada de ' + posoeA + ' y ' + posoeI + '. La acumulación explora, reúne y multiplica; la depuración condensa, estructura y mantiene la coherencia. Su interacción con ' + rezonans + ', ' + peropt + ', ' + illusion + ' y ' + alio + ' alimenta la emergencia de las ' + modalites + '.</p>',
        h_tools: 'Las cuatro herramientas',
        h_features: 'Dinámicas operativas',
        features: [
          'Activadores perceptivos e integrativos del Axis.',
          'Convierten flujos heterogéneos en matrices operativas.',
          'Son impulsados por la acción cruzada de los Engranajes Posœnnoïaque y Posœnnoïque.',
          'Trabajan en interdependencia viva con los cuatro Pilares.',
          'Participan en el nacimiento de las Modalidades operativas.'
        ],
        h_questions: 'Aplicaciones / referencias',
        questions: [
          '¿Qué Herramienta conviene más ahora: añadir, ampliar la lectura, sostener varios tiempos a la vez o estabilizar la pluralidad?',
          '¿El proceso debe empezar por acumulación o por depuración?',
          '¿Qué Pilar ya está activo bajo la superficie de la Herramienta?',
          '¿Qué tipo de matriz debe producirse aquí: narrativa, conceptual, visual, relacional, temporal?'
        ],
        example_title: 'Ej.',
        example: 'Una obra puede pasar por ' + addition + ' para integrar materiales heterogéneos, por ' + superposition + ' para abrir varias lecturas, por ' + instantane + ' para densificar el instante y por ' + sujet + ' para dar a esa pluralidad una tenencia viva y coherente.',
        h_family: 'Vínculos sistémicos',
        family_1: '<p><strong>Con los Pilares:</strong> ' + rezonans + ' afina, ' + peropt + ' relanza, ' + illusion + ' desvela, y ' + alio + ' transforma por la alteridad. Las Herramientas reciben esos impulsos y los vuelven operables.</p>',
        family_2: '<p><strong>Con los Engranajes:</strong> ' + posoeA + ' empuja a las Herramientas a recolectar, explorar y complejizar; ' + posoeI + ' condensa, estructura y estabiliza lo reunido. Esa tensión da nacimiento a las ' + modalites + '.</p>',
        h_wordbuild: 'Construcción / lógica del grupo',
        word_blocks: [
          { head: '1) Activación', text: 'Las Herramientas no sólo describen: desencadenan una operación en la percepción, el pensamiento, la creación y la relación.' },
          { head: '2) Paso', text: 'Transforman la materia bruta en forma trabajable, sin reducir la multiplicidad que alojan.' },
          { head: '3) Interdependencia', text: 'Su acción nunca ocurre sola: se nutre de los Pilares, es movida por los Engranajes y se prolonga en las Modalidades operativas.' }
        ],
        word_notes: [
          'Números-guía: 10 / 9 / 8 / 3.',
          'Lógica compartida: percepción, agenciamiento, ampliación, estabilización.',
          'Estatuto del grupo: cuatro herramientas fundamentales del Axis.'
        ],
        cta_translate: 'Proponer una traducción del concepto'
      };
    }

    return {
      title: CANON.title,
      kicker: 'Extrait de <em>' + axis + '</em><br />(Activateurs perceptifs et intégratifs de l’' + organon + ')',
      h_def: 'Définition opérative',
      def_short: toolsTitle + ' sont les activateurs perceptifs et intégratifs : ' + addition + ', ' + superposition + ', ' + instantane + ', ' + sujet + '. Alimentés par l’oscillation des Engrenages, ils transforment les flux disparates en matrices opératives.',
      def_long:
        '<p>' + toolsTitle + ' agissent comme des agents de passage : des entités filtrantes capables de transmuter les matières vibratoires de ' + posoennoia + ' en dispositifs activables. Chacun porte un protocole d’agencement entre l’informe et la forme, entre la densité intuitive et la structure symbolique.</p>' +
        '<p>' + addition + ' opère par ajustement et recombinaison ; ' + superposition + ' ouvre les lectures multiangulaires ; ' + instantane + ' élargit la perception par strates temporelles simultanées ; ' + sujet + ' stabilise cette pluralité sans l’uniformiser.</p>' +
        '<p>Chaque Outil est mis en mouvement par l’activation croisée de ' + posoeA + ' et de ' + posoeI + '. L’accumulation explore, rassemble et démultiplie ; l’épure condense, structure et maintient la cohérence. Leur interaction avec ' + rezonans + ', ' + peropt + ', ' + illusion + ' et ' + alio + ' nourrit l’émergence des ' + modalites + '.</p>',
      h_tools: 'Les quatre outils',
      h_features: 'Dynamiques opératives',
      features: [
        'Activateurs perceptifs et intégratifs de l’Axis.',
        'Ils convertissent les flux hétérogènes en matrices opératives.',
        'Ils sont mus par l’action croisée des Engrenages posœnnoïaque et posœnnoïque.',
        'Ils travaillent en inter-indépendance vivante avec les quatre Piliers.',
        'Ils participent à la naissance des Modalités opératives.'
      ],
      h_questions: 'Applications / repères',
      questions: [
        'Quel Outil convient le mieux à la nécessité présente : ajouter, élargir la lecture, tenir plusieurs temps ensemble, ou stabiliser la pluralité ?',
        'Le processus doit-il commencer par l’accumulation ou par l’épure ?',
        'Quel Pilier agit déjà sous la surface de l’Outil mobilisé ?',
        'Quelle matrice faut-il produire ici : narrative, conceptuelle, visuelle, relationnelle, temporelle ?'
      ],
      example_title: 'Ex.',
      example: 'Une œuvre peut passer par ' + addition + ' pour intégrer des matériaux hétérogènes, par ' + superposition + ' pour ouvrir plusieurs lectures, par ' + instantane + ' pour densifier l’instant, et par ' + sujet + ' pour donner à cette pluralité une tenue vivante et cohérente.',
      h_family: 'Liens systémiques',
      family_1: '<p><strong>Avec les Piliers :</strong> ' + rezonans + ' accorde, ' + peropt + ' relance, ' + illusion + ' dévoile, et ' + alio + ' transforme par l’altérité. Les Outils reçoivent ces impulsions et les rendent opérables.</p>',
      family_2: '<p><strong>Avec les Engrenages :</strong> ' + posoeA + ' pousse les Outils à collecter, explorer et complexifier ; ' + posoeI + ' condense, structure et stabilise ce qui a été recueilli. Cette tension donne naissance aux ' + modalites + '.</p>',
      h_wordbuild: 'Construction / logique du groupe',
      word_blocks: [
        { head: '1) Activation', text: 'Les Outils ne décrivent pas seulement : ils déclenchent une opération dans la perception, la pensée, la création et la relation.' },
        { head: '2) Passage', text: 'Ils transforment la matière brute en forme travaillable, sans réduire la multiplicité qu’ils accueillent.' },
        { head: '3) Interdépendance', text: 'Leur action ne se produit jamais seule : elle se nourrit des Piliers, se laisse mouvoir par les Engrenages, et se prolonge dans les Modalités opératives.' }
      ],
      word_notes: [
        'Nombres-guides : 10 / 9 / 8 / 3.',
        'Logique commune : perception, agencement, élargissement, stabilisation.',
        'Statut de groupe : quatre outils fondamentaux de l’Axis.'
      ],
      cta_translate: 'Proposer une traduction du concept'
    };
  }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], activeKey:'', lang:'fr' };
  var AUDIO_UI = {
    fr: { general: 'Écouter le texte', block: 'Écouter ce bloc', stop: 'Arrêter la lecture' },
    en: { general: 'Listen to the text', block: 'Listen to this section', stop: 'Stop playback' },
    es: { general: 'Escuchar el texto', block: 'Escuchar este bloque', stop: 'Detener la lectura' }
  };

  function audioUI(lang){ return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr; }
  function getAudioRoots(){ return document.querySelectorAll(ROOT_SEL); }
  function getDetailBlocks(root){ return root ? root.querySelectorAll('.po-lex-details') : []; }

  function getTextValue(el){
    if (!el) return '';
    var txt = '';
    try{ txt = el.textContent || el.innerText || ''; }catch(e){ txt = ''; }
    return clampStr(txt).replace(/\s+/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-wrap, .po-axis-audio-btn');
    for (var i = 0; i < btns.length; i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ['title', 'kicker', 'h_def', 'def_short', 'def_long', 'h_tools', 'tool_cards'];
    for (var i = 0; i < slots.length; i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title') || detail.querySelector('summary');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary') || clone.querySelector('summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = '';
    for (var i = 0; i < pieces.length; i++){
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + ' ' : '') + piece).length > 220){
        if (current) out.push(current.trim());
        current = piece;
      } else {
        current = current ? (current + ' ' + piece) : piece;
      }
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getSpeechLangCode(lang){
    var L = normLang(lang);
    if (L === 'en') return 'en-US';
    if (L === 'es') return 'es-ES';
    return 'fr-FR';
  }

  function ensureAudioStyles(){
    if (!document || document.getElementById('po-outils-audio-style')) return;
    var style = document.createElement('style');
    style.id = 'po-outils-audio-style';
    style.textContent =
      '.po-axis-audio-wrap{margin:12px 0 14px;display:flex;justify-content:flex-start;}' +
      '.po-axis-audio-btn{appearance:none;border:1px solid rgba(0,0,0,.14);background:rgba(0,0,0,.03);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;font-weight:800;line-height:1.2;cursor:pointer;display:inline-flex;align-items:center;gap:8px;max-width:100%;}' +
      '.po-axis-audio-btn:hover{background:rgba(0,0,0,.05);}' +
      '.po-axis-audio-btn.is-playing{background:rgba(0,0,0,.08);}' +
      '.po-axis-audio-btn__icon{display:inline-block;min-width:1em;text-align:center;}' +
      '.po-axis-section[data-po-lex-id="outils"] .po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}' +
      '.po-axis-section[data-po-lex-id="outils"] .po-axis-audio-btn__label{white-space:normal;}' +
      '@media (max-width:760px){.po-axis-section[data-po-lex-id="outils"] .po-lex-summary{align-items:flex-start;}.po-axis-section[data-po-lex-id="outils"] .po-lex-summary .po-axis-audio-btn{margin-left:0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role);
    var icon = document.createElement('span');
    icon.className = 'po-axis-audio-btn__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '⏵';
    var label = document.createElement('span');
    label.className = 'po-axis-audio-btn__label';
    btn.appendChild(icon);
    btn.appendChild(label);
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));
        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector('.po-lex-details');
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }
    var details = getDetailBlocks(root);
    for (var i = 0; i < details.length; i++){
      var detail = details[i];
      var summary = detail.querySelector('.po-lex-summary') || detail.querySelector('summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function setButtonVisualState(btn, lang, isPlaying){
    if (!btn) return;
    var ui = audioUI(lang);
    var role = btn.getAttribute('data-po-audio-role') || 'detail';
    var label = btn.querySelector('.po-axis-audio-btn__label');
    var icon = btn.querySelector('.po-axis-audio-btn__icon');
    if (btn.classList && btn.classList.toggle) btn.classList.toggle('is-playing', !!isPlaying);
    if (icon) icon.textContent = isPlaying ? '⏸' : '⏵';
    if (label) label.textContent = isPlaying ? ui.stop : (role === 'general' ? ui.general : ui.block);
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : '';
    for (var i = 0; i < btns.length; i++){
      var btn = btns[i];
      var role = btn.getAttribute('data-po-audio-role') || 'detail';
      var key = (role === 'general') ? 'general' : ('detail:' + clampStr(btn.getAttribute('data-po-audio-index')));
      setButtonVisualState(btn, lang, !!activeKey && key === activeKey);
    }
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general'){
      units.push({ role:'general', index:-1 });
      for (var i = 0; i < details.length; i++) units.push({ role:'detail', index:i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j = start; j < details.length; j++) units.push({ role:'detail', index:j });
    return units;
  }

  function stopAudio(){
    try{ if (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) PO_AUDIO_SYNTH.cancel(); }catch(e){}
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) refreshAudioLabels(roots[i], readLang());
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = readLang();
  }

  function playCurrentUnit(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    if (PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    var text = '';
    if (unit.role === 'general'){
      PO_AUDIO_STATE.activeKey = 'general';
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = 'detail:' + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){ detail.open = true; text = collectDetailText(detail); }
    }
    refreshAudioLabels(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang || readLang());
    PO_AUDIO_STATE.chunks = splitTextForSpeech(text);
    if (!PO_AUDIO_STATE.chunks.length){ PO_AUDIO_STATE.unitPos += 1; playCurrentUnit(); return; }
    speakNextChunk();
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.root) return;
    if (!PO_AUDIO_STATE.chunks.length){ PO_AUDIO_STATE.unitPos += 1; playCurrentUnit(); return; }
    var chunk = PO_AUDIO_STATE.chunks.shift();
    var utter = new SpeechSynthesisUtterance(chunk);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang || readLang());
    utter.rate = 0.95;
    utter.onend = function(){ speakNextChunk(); };
    utter.onerror = function(){ speakNextChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ speakNextChunk(); }
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = readLang();
    playCurrentUnit();
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i = 0; i < btns.length; i++){
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = (role === 'general') ? 'general' : ('detail:' + index);
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){ stopAudio(); return; }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || readLang());
    }
  }

  function applyLangEverywhere(lang){
    var L = storeLang(lang);
    stopAudio();
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++){
      var root = roots[i];
      var F = content(L);
      setImage(root, 'title_img', URLS.title, F.title);
      setSlotTextLexical(root, 'title', F.title);
      setSlotHTML(root, 'kicker', F.kicker);
      setSlotText(root, 'h_def', F.h_def);
      setSlotHTML(root, 'def_short', F.def_short);
      setSlotHTML(root, 'def_long', F.def_long);
      setSlotText(root, 'h_tools', F.h_tools);
      setSlotHTML(root, 'tool_cards', buildToolCards(L));
      setSlotText(root, 'h_features', F.h_features);
      setSlotText(root, 'hint_fold', lab(L, 'open'));
      renderListInto(root, 'features', F.features);
      setSlotText(root, 'h_questions', F.h_questions);
      setSlotText(root, 'hint_fold2', lab(L, 'open'));
      renderListInto(root, 'questions', F.questions);
      setSlotHTML(root, 'example_box', buildExampleBox(F));
      setSlotText(root, 'h_family', F.h_family);
      setSlotText(root, 'hint_fold3', lab(L, 'open'));
      setSlotHTML(root, 'family_1', F.family_1);
      setSlotHTML(root, 'family_2', F.family_2);
      setSlotText(root, 'h_wordbuild', F.h_wordbuild);
      renderWordBlocks(root, 'wordbuild_blocks', F.word_blocks);
      renderListInto(root, 'wordbuild_notes', F.word_notes);
      setSlotText(root, 'cta_translate', F.cta_translate);
      var bar = root.querySelector('.po-langbar');
      if (bar) bar.setAttribute('aria-label', lab(L, 'choose_lang'));
      root.querySelectorAll('.po-langbtn').forEach(function(btn){
        var isActive = normLang(btn.getAttribute('data-po-lang')) === L;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      protectKeywordsInElement(root);
    }
    initAudioEverywhere(L);
    notifyLocaleChanged();
  }

  function bindButtons(){
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++){
      var bar = roots[i].querySelector('.po-langbar');
      if (!bar || bar.__poLangBound) continue;
      bar.addEventListener('click', function(ev){
        var btn = ev.target && ev.target.closest ? ev.target.closest('.po-langbtn[data-po-lang]') : null;
        if (!btn) return;
        ev.preventDefault();
        ev.stopPropagation();
        applyLangEverywhere(btn.getAttribute('data-po-lang'));
      });
      bar.__poLangBound = true;
    }
  }

  function init(){
    bindButtons();
    applyLangEverywhere(readLang());
  }

  window.PoOutilsTrilangProtected20260401 = {
    init: init,
    setLang: applyLangEverywhere,
    getLang: readLang,
    normLang: normLang,
    stopAudio: stopAudio
  };

  try{
    if (!window.GoodyTwinLang){
      window.GoodyTwinLang = { init:init, getLang:readLang, setLang:applyLangEverywhere };
    } else {
      if (typeof window.GoodyTwinLang.getLang !== 'function') window.GoodyTwinLang.getLang = readLang;
      if (typeof window.GoodyTwinLang.setLang !== 'function') window.GoodyTwinLang.setLang = applyLangEverywhere;
      if (typeof window.GoodyTwinLang.init !== 'function') window.GoodyTwinLang.init = init;
    }
  }catch(e){}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
